import _ from 'underscore';
import {
  COMPONENT_TYPE_MAPPING,
  DATA_SOURCE_KEY_MAPPING,
  WEBSITE_SOURCE_DATA_KEY_MAPPING,
  getWebsiteSourceDataByKey,
  getComponentByType,
  mapWSDHoursToHours,
  getDefaultHoursConfig,
} from '@bingads-webui-campaign-react/smart-component-util';

/**
 * Read booking availability.
 * 1. Read from WebsiteSourceData.Appointment.AppointmentHours
 * 2. Fallback to Business Hours
 * 3. Fallback to default hours
 * @param {Object} siteConfig Complete site config
 * @returns {Array} Booking availability
 */
export const proxyReadHoursConfig = (siteConfig) => {
  const defaultHours = getDefaultHoursConfig();

  const appointment = getWebsiteSourceDataByKey(
    siteConfig,
    WEBSITE_SOURCE_DATA_KEY_MAPPING.Appointment
  ) || {};
  const bookingHours = appointment.AppointmentHours || [];

  // Business Hours may store in two places: Business Hours Component and Contact Component.
  const bizHourConfig = getComponentByType(siteConfig, COMPONENT_TYPE_MAPPING.BusinessHours);
  const contactConfig = getComponentByType(siteConfig, COMPONENT_TYPE_MAPPING.Contact);
  let businessHours = _.propertyOf(bizHourConfig)(DATA_SOURCE_KEY_MAPPING.BusinessHours);
  if (_.isEmpty(bizHourConfig)) {
    businessHours = _.propertyOf(contactConfig)(DATA_SOURCE_KEY_MAPPING.BusinessHours);
  }


  let hours = defaultHours;
  if (!_.isEmpty(bookingHours)) {
    hours = mapWSDHoursToHours(bookingHours);
  } else if (!_.isEmpty(businessHours)) {
    hours = businessHours;
  }

  // Filter out "Holidays", not support holidays now.
  hours = _.filter(hours, item => item.day !== 'holiday');

  return hours;
};
